var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5071 7.56572C18.7328 7.88885 18.9304 8.23073 19.0978 8.5876L21.5259 9.9376C21.8291 11.2955 21.8323 12.7033 21.5353 14.0626L19.0978 15.4126C18.9304 15.7695 18.7328 16.1113 18.5071 16.4345L18.554 19.2188C17.525 20.1566 16.307 20.863 14.9821 21.2907L12.5915 19.8563C12.1983 19.8845 11.8035 19.8845 11.4103 19.8563L9.02901 21.2813C7.69992 20.8614 6.47797 20.1577 5.44776 19.2188L5.49463 16.4438C5.27082 16.1162 5.07333 15.7714 4.90401 15.4126L2.47588 14.0626C2.17269 12.7047 2.16949 11.2969 2.46651 9.9376L4.90401 8.5876C5.07133 8.23073 5.26893 7.88885 5.49463 7.56572L5.44776 4.78135C6.4768 3.84363 7.69474 3.13716 9.01963 2.70947L11.4103 4.14385C11.8035 4.11572 12.1983 4.11572 12.5915 4.14385L14.9728 2.71885C16.3018 3.13875 17.5238 3.84249 18.554 4.78135L18.5071 7.56572Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.07ea79ac70a96130078da5a8066e813e.svg";
export { ForwardRef as ReactComponent };